<!--数据分析组件(成本分析和收益分析)-->
<template>
    <div>
        <div class="search">
            <el-date-picker
                    v-model="value"
                    type="daterange"
                    range-separator="至"
                    :start-placeholder="startDate"
                    :end-placeholder="endDate"
                    value-format="yyyy-MM-dd"
            >
            </el-date-picker>
            <el-button type="info" icon="el-icon-search" @click="searchCharts" plain class="no-blur">搜索</el-button>
        </div>
        <costAnalysis ref="child1"></costAnalysis>
        <revenueAnalysis ref="child2"></revenueAnalysis>
    </div>
</template>

<script>
    import revenueAnalysis from "../../../components/revenueAnalysis";
    import costAnalysis from "../../../components/costAnalysis";
    const formatTime = require('../../../utils/formatTime')
    export default {
        name: "costAnalyse",
        data(){
            return{
                value: '', // 日期
                startDate: '', //初始化开始时间
                endDate: ''
            }
        },
        components: {
            revenueAnalysis,
            costAnalysis
        },
        created() {
            this.startDate = formatTime(-365)//七天前
            this.endDate = formatTime(0)//当前时间
        },
        methods:{
            searchCharts(){
                document.querySelector(".no-blur").blur();
                console.log(this.value[0],this.value[1]);
                this.startDate = this.value[0];
                this.endDate = this.value[1];
                this.$refs.child1.getData(this.value);
                this.$refs.child2.getData(this.value);
               // this.value = '' // 传参结束清空
            }
        }
    }
</script>

<style scoped>
.search{
    margin-left: 30px;
    margin-bottom: 10px;
}
</style>
